export const MAX_REVIEW_STARS = 5;
export const RATING_STARS_VALUES = ['', '1', '2', '3', '4', '5'];
export const PAGE_SIZE = 10;
